'use strict'

export const cardPropertyConfigurableMixin = {
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    const componentProps = this.tabProp.componentProps
    if (componentProps) {
      if (componentProps.class === undefined) {
        this.$set(componentProps, 'class', null)
      }
      if (componentProps.bottomMessage === undefined) {
        this.$set(componentProps, 'bottomMessage', null)
      }
    }
    return {
    }
  },
  computed: {
    componentProps: function () {
      return (this.tabProp && this.tabProp.componentProps) || {}
    },
    clazz: function () {
      let clazz
      if (this.componentProps.class) {
        if (typeof this.componentProps.class === 'string') {
          clazz = this.componentProps.class
        } else if (typeof this.componentProps.class === 'function') {
          const value = this.object[this.tabProp.key]
          clazz = this.componentProps.class(value, this.object)
        }
      }
      return clazz + ' ' || ''
    }
  }
}
